const organizations = {
    require_membership: 'Người dùng phải là thành viên của tổ chức mới có thể tiếp tục.',
    role_names_not_found: 'Phát hiện tên vai trò không hợp lệ: {{names,list(type:conjunction)}}. Vui lòng tạo các vai trò này trước khi tiếp tục.',
};
export default Object.freeze(organizations);
